<div class="d-flex flex-column">
  <h3 class="semi-bold">Still unsure? Book risk-free!</h3>

  <p class="mt-2">
    You can cancel your trip within<br />24 hours at no charge — our<br />money-back guarantee
    means<br />you'll receive a full refund,<br />no questions asked.
  </p>
</div>

<img
  src="/assets/images/currency-shield.webp"
  alt="currency-shield"
  width="140"
  height="140"
  class="img"
/>
